import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import redsImg from '../../assets/images/bet-on-poker/reds.png';
import cloverImg from '../../assets/images/bet-on-poker/clover.png';
import pikesImg from '../../assets/images/bet-on-poker/pikes.png';
import heartImg from '../../assets/images/bet-on-poker/heard.png';
import diamontImg from '../../assets/images/bet-on-poker/diamont.png';
import { BOARD_CARD_WIN_TYPE, MARKET_GROUP_TYPES, MARKET_TYPES } from '../../enums/betTypesEnum';
import { gameStore } from '../../store/gameStore';
import { winningAmountStore } from '../../store/winningAmountStore';
import { FlopCardsRow } from './flopCardsRow';

const FlopCardsData = [
  {
    groupType: MARKET_GROUP_TYPES.RedCards,
    isHeaderKeys: ['COLOR', 'OVER', 'UNDER'],
    id: 1,
    winningType: BOARD_CARD_WIN_TYPE.Red,
    betTypeInfo: [
      {
        imgSrc: redsImg,
        name: 'REDS',
      },
      {
        marketType: MARKET_TYPES.Over,
      },
      {
        marketType: MARKET_TYPES.Under,
      },
    ],
  },
  {
    groupType: MARKET_GROUP_TYPES.Clubs,
    isHeaderKeys: ['SUIT'],
    id: 2,
    winningType: BOARD_CARD_WIN_TYPE.Clubs,
    betTypeInfo: [
      {
        imgSrc: cloverImg,
        name: 'CLUBS',
      },
      {
        marketType: MARKET_TYPES.Over,
      },
      {
        marketType: MARKET_TYPES.Under,
      },
    ],
  },
  {
    groupType: MARKET_GROUP_TYPES.Spades,
    id: 3,
    winningType: BOARD_CARD_WIN_TYPE.Spades,
    betTypeInfo: [
      {
        imgSrc: pikesImg,
        name: 'SPADES',
      },
      {
        marketType: MARKET_TYPES.Over,
      },
      {
        marketType: MARKET_TYPES.Under,
      },
    ],
  },
  {
    groupType: MARKET_GROUP_TYPES.Hearts,
    id: 4,
    winningType: BOARD_CARD_WIN_TYPE.Hearts,
    betTypeInfo: [
      {
        imgSrc: heartImg,
        name: 'HEARTS',
      },
      {
        marketType: MARKET_TYPES.Over,
      },
      {
        marketType: MARKET_TYPES.Under,
      },
    ],
  },
  {
    groupType: MARKET_GROUP_TYPES.Diamonds,
    id: 5,
    winningType: BOARD_CARD_WIN_TYPE.Diamonds,
    betTypeInfo: [
      {
        imgSrc: diamontImg,
        name: 'DIAMONDS',
      },
      {
        marketType: MARKET_TYPES.Over,
      },
      {
        marketType: MARKET_TYPES.Under,
      },
    ],
  },
];

export const FlopCardsBets = observer(({ handleDoChip }) => {
  const { roundBetTypesInfo } = gameStore;
  const { winningBoardCardTypes } = winningAmountStore;
  const t = useTranslation();
  return (
    <div className='flop-cards-wrapper'>
      {FlopCardsData.map(({ isHeaderKeys, betTypeInfo, groupType, id }) => {
        const currentGroupTypesInfo = roundBetTypesInfo?.find(
          (item) => item.groupType === groupType
        );
        return (
          <div key={id} className='flop-cards-row'>
            {isHeaderKeys && (
              <div className='flop-c-info-row'>
                {isHeaderKeys.map((item, index) => (
                  <div key={item.concat(`${index}`)} className='flop-c-info-row-inner'>
                    <p className='flop-c-info-row-inner-text'>
                      {t(item)} {!index && <span>{currentGroupTypesInfo?.nameNumber}</span>}
                    </p>
                  </div>
                ))}
              </div>
            )}
            <FlopCardsRow
              groupType={groupType}
              betTypeInfo={betTypeInfo}
              handleDoChip={handleDoChip}
              currentGroupTypesInfo={currentGroupTypesInfo}
              winningBoardCardTypes={winningBoardCardTypes}
            />
          </div>
        );
      })}
    </div>
  );
});
